"use client"

import { useState } from "react"

const HotelForm = ({ onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    item_name: "",
    description: "",
    quantity: 1,
    cost_price: 0,
    selling_price: 0,
    margin: 0,
    item_type: "hotel",
    // Hotel specific fields
    hotel_name: "",
    location: "",
    check_in_date: "",
    check_out_date: "",
    room_type: "",
    number_of_rooms: 1,
    number_of_guests: 1,
    meal_plan: "",
    star_rating: "",
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => {
      const updated = { ...prev, [name]: value }

      // Auto-calculate margin and total when prices change
      if (name === "cost_price" || name === "selling_price") {
        const costPrice = Number.parseFloat(name === "cost_price" ? value : updated.cost_price) || 0
        const sellingPrice = Number.parseFloat(name === "selling_price" ? value : updated.selling_price) || 0

        if (costPrice > 0) {
          updated.margin = Math.round(((sellingPrice - costPrice) / costPrice) * 100)
        }
        updated.total_amount = sellingPrice * updated.quantity
      }

      if (name === "quantity") {
        updated.total_amount = updated.selling_price * Number.parseInt(value)
      }

      return updated
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(formData)
  }

  return (
    <form onSubmit={handleSubmit} className="item-form">
      <div className="form-grid">
        <div className="form-group">
          <label>Item Name *</label>
          <input
            type="text"
            name="item_name"
            value={formData.item_name}
            onChange={handleInputChange}
            placeholder="e.g., Dubai Hotel Booking"
            required
          />
        </div>

        <div className="form-group">
          <label>Hotel Name *</label>
          <input
            type="text"
            name="hotel_name"
            value={formData.hotel_name}
            onChange={handleInputChange}
            placeholder="e.g., Burj Al Arab"
            required
          />
        </div>

        <div className="form-group">
          <label>Location *</label>
          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleInputChange}
            placeholder="e.g., Dubai Marina"
            required
          />
        </div>

        <div className="form-group">
          <label>Star Rating</label>
          <select name="star_rating" value={formData.star_rating} onChange={handleInputChange}>
            <option value="">Select Rating</option>
            <option value="3">3 Star</option>
            <option value="4">4 Star</option>
            <option value="5">5 Star</option>
          </select>
        </div>

        <div className="form-group">
          <label>Check-in Date *</label>
          <input
            type="date"
            name="check_in_date"
            value={formData.check_in_date}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Check-out Date *</label>
          <input
            type="date"
            name="check_out_date"
            value={formData.check_out_date}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Room Type *</label>
          <select name="room_type" value={formData.room_type} onChange={handleInputChange} required>
            <option value="">Select Room Type</option>
            <option value="standard">Standard Room</option>
            <option value="deluxe">Deluxe Room</option>
            <option value="suite">Suite</option>
            <option value="presidential">Presidential Suite</option>
          </select>
        </div>

        <div className="form-group">
          <label>Number of Rooms *</label>
          <input
            type="number"
            name="number_of_rooms"
            value={formData.number_of_rooms}
            onChange={handleInputChange}
            min="1"
            required
          />
        </div>

        <div className="form-group">
          <label>Number of Guests *</label>
          <input
            type="number"
            name="number_of_guests"
            value={formData.number_of_guests}
            onChange={handleInputChange}
            min="1"
            required
          />
        </div>

        <div className="form-group">
          <label>Meal Plan</label>
          <select name="meal_plan" value={formData.meal_plan} onChange={handleInputChange}>
            <option value="">No Meals</option>
            <option value="breakfast">Breakfast Only</option>
            <option value="half_board">Half Board</option>
            <option value="full_board">Full Board</option>
            <option value="all_inclusive">All Inclusive</option>
          </select>
        </div>

        <div className="form-group">
          <label>Quantity *</label>
          <input
            type="number"
            name="quantity"
            value={formData.quantity}
            onChange={handleInputChange}
            min="1"
            required
          />
        </div>

        <div className="form-group">
          <label>Cost Price *</label>
          <input
            type="number"
            name="cost_price"
            value={formData.cost_price}
            onChange={handleInputChange}
            step="0.01"
            min="0"
            required
          />
        </div>

        <div className="form-group">
          <label>Selling Price *</label>
          <input
            type="number"
            name="selling_price"
            value={formData.selling_price}
            onChange={handleInputChange}
            step="0.01"
            min="0"
            required
          />
        </div>
      </div>

      <div className="form-group full-width">
        <label>Description</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          placeholder="Additional details about the hotel booking..."
          rows="3"
        />
      </div>

      <div className="pricing-summary">
        <div className="summary-item">
          <span>Margin: {formData.margin}%</span>
        </div>
        <div className="summary-item">
          <span>Total Amount: ${(formData.selling_price * formData.quantity).toFixed(2)}</span>
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn-primary">
          Add Hotel Booking
        </button>
      </div>
    </form>
  )
}

export default HotelForm
